import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import Fund from './Fund'
import { connect } from 'react-redux'
import FundQuantityForm from 'components/FundQuantityForm'
import FundHashForm from 'components/FundHashForm'
import * as selectors from 'selectors'
import Button from 'components/Button'
import Paper from 'material-ui/Paper'
import AddIcon from 'material-ui-icons/Add'
import { stopEditingFund } from 'actions/fund'
import compose from 'recompose/compose'
import classNames from 'classnames'
import loadUserAndFetchFunds from 'utils/loadUserAndFetchFunds'
import { Link } from 'react-router-dom'
import Tooltip from 'material-ui/Tooltip'

const styles = theme => ({
  root: {
    marginBottom: 60,
  },
  lines: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  darker: {
    backgroundColor: theme.palette.background.contentFrame,
  },
  column: {
    flexGrow: 1,
    padding: 20,
    width: '33%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      paddingBottom: 40,
      paddingTop: 40,
    },
  },
  cardList: {
    '& > *': {
      marginBottom: 20,
    },
    height: '100%',
  },
  tooltip: {
    display: 'block',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    paddingTop: 20,
    marginTop: -20,
    backgroundColor: theme.palette.background.default,
    '$darker &': {
      backgroundColor: theme.palette.background.contentFrame,
    },
  },
  tooltipText: { fontSize: 14 },
  addBtnRoot: {
    flexGrow: 1,
    height: '100%',
  },
  addBtnLabel: {
    flexDirection: 'column',
    display: 'flex',
  },
  addCard: {
    minHeight: 200,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  empty: {
    textAlign: 'center',
  },
  bottomActions: {
    textAlign: 'center',
    marginTop: 80,
  },
})

class Funds extends React.Component {
  linesElements = {}
  initialState = {
    hash: {
      edit: false,
    },
    quantity: {
      edit: false,
    },
    exchange: {
      edit: false,
    },
  }
  state = { ...this.initialState }
  addForm = type => {
    this.setState({
      ...this.initialState,
      [type]: { edit: true },
    })
  }
  closeForm = type => {
    this.setState({ [type]: { edit: false } })
  }
  render() {
    const { classes, funds, closeEditingMode } = this.props
    const lines = [
      {
        title: 'Public Address',
        helpText: 'Allows to keep the balance synchronized',
        Form: FundHashForm,
        type: 'hash',
        tooltip:
          'Give a public address (hash) of your funds, totalbalance will fetch the amount itself',
        funds: funds.filter(f => f.type === 'hash'),
      },
      {
        title: 'Manual',
        helpText: 'Give manually the balance of your fund',
        Form: FundQuantityForm,
        type: 'quantity',
        tooltip: 'Associate a currency with an amount',
        funds: funds.filter(f => f.type === 'quantity'),
      },
      {
        title: 'Exchange',
        helpText: 'Connect an exchange service',
        disabled: true,
        Form: () => null,
        type: 'exchange',
        tooltip:
          'Coming soon.\nAllows you to plug you Kraken account for instance',
        funds: funds.filter(f => f.type === 'exchange'),
      },
    ]
    return (
      <div className={classes.root}>
        <div className={classes.lines}>
          {lines.map(
            (
              { title, Form, type, funds, helpText, disabled, tooltip },
              index
            ) => (
              <div
                key={type}
                className={classNames(classes.column, {
                  [classes.darker]: index % 2 === 1,
                })}
              >
                <div
                  className={classes.cardList}
                  ref={ref => (this.linesElements[type] = ref)}
                >
                  <Tooltip
                    title={tooltip}
                    placement="bottom"
                    className={classes.tooltip}
                    classes={{ tooltip: classes.tooltipText }}
                  >
                    <Paper className={classes.addCard}>
                      <Button
                        color="primary"
                        innerClasses={{
                          root: classes.addBtnRoot,
                          label: classes.addBtnLabel,
                        }}
                        disabled={disabled}
                        aria-label="add"
                        onClick={event => {
                          this.setState({ [type]: { edit: true } }, () =>
                            window.scrollTo(
                              0,
                              this.linesElements[type].offsetTop
                            )
                          )
                        }}
                      >
                        <AddIcon style={{ width: 60, height: 60 }} />
                        <Typography type="display1" gutterBottom>
                          {title}
                        </Typography>
                        <Typography type="body2" gutterBottom>
                          {helpText}
                        </Typography>
                      </Button>
                    </Paper>
                  </Tooltip>
                  {!funds.length && (
                    <div className={classes.empty}>
                      <Typography type="body1" gutterBottom>
                        There is no fund here yet.
                      </Typography>
                    </div>
                  )}
                  {this.state[type].edit && (
                    <Form
                      name={`${type}-new`}
                      onExit={() => this.closeForm(type)}
                    />
                  )}
                  {funds.map(
                    (fund, index) =>
                      fund._edit ? (
                        <Form
                          name={`${type}-${fund._uid}`}
                          key={index}
                          initialValues={fund}
                          onExit={() => closeEditingMode(fund)}
                        />
                      ) : (
                        <Fund key={index} fund={fund} />
                      )
                  )}
                </div>
              </div>
            )
          )}
        </div>
        <div className={classes.bottomActions}>
          {funds.length > 0 && (
            <Button big raised component={Link} color="accent" to="/">
              Check out your dashboard
            </Button>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValue(state),
})
const mapDispatchToProps = dispatch => ({
  closeEditingMode: fund => dispatch(stopEditingFund(fund)),
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
  loadUserAndFetchFunds
)(Funds)



// WEBPACK FOOTER //
// ./src/components/Funds.js